import React, { useEffect, useState } from 'react';
import './Header.scss';
import {motion} from 'framer-motion';
import {images} from '../../constants';  //including all the images of assets folder
import {BiDownload} from 'react-icons/bi';  //importing icons from lib we installed
import {AppWrap} from '../../wrapper';   //importing hoc this will also force component to take full space of screen

import linkedinLogo from '../../assets/linkedin.png';
import githubLogo from '../../assets/github.png';
import codingNinjaLogo from '../../assets/codingninja.png';
import gfgLogo from '../../assets/gfg.png';
import codechefLogo from '../../assets/codechef.png';
import leetcodeLogo from '../../assets/leetcode.png';

import { client } from '../../client';  //importing backend connection files

const Header = () => {
  const [resume, setResume]= useState([]);  //creating a empty state for dynamic resume links

  useEffect(()=>{  //requesting data from backend
    const query= '*[_type == "resume"]';  //for fetching about section from backend
    client.fetch(query).then((data)=>{ setResume(data); })  //will return a promise
  },[]); //passing empty array as only want to run it once at the start component get mount type

  var mainLink;
  resume.map((i)=>( mainLink=i.resume_link ));  //mapping each resumelink and setting it equal to i

  return (
    <div id='home' className='app__header app__flex'>
      <motion.div 
        whileInView={{x:[-150,0], opacity:[0,1]}}
        transition={{duration:1}}
        className='app__header-info'>
          <div className="app__header-badge">
            <div className='badge-cmp app__flex main-head'>
              <h2>👋🏻 Hi!, I'm Prathya Thakur</h2>
              <p>Code Wizard with a love for all things technical. I can turn lines of code into magic, and I'm always up for a good challenge. When I'm not busy over some project or problem, you can find me nerding out over the latest technologies. Just don't ask me to fix your computer (I can fix it 😉) but I'm a professional, not a superhero...
              </p>
            </div>
            <div className='about-txt links'>
              <div>
                <a href="https://www.linkedin.com/in/thakurprathya/" target="__blank">
                  <img src={linkedinLogo} alt="profile" />
                </a>
              </div>
              <div>
                <a href="https://github.com/thakurprathya" target="__blank">
                  <img src={githubLogo} alt="profile" />
                </a>
              </div>
              <div>
                <a href="https://www.codechef.com/users/thakurprathya" target="__blank">
                  <img src={codechefLogo} alt="profile" />
                </a>
              </div>
              <div>
                <a href="https://leetcode.com/u/thakurprathya/" target="__blank">
                  <img src={leetcodeLogo} alt="profile" />
                </a>
              </div>
              <div>
                <a href="https://www.naukri.com/code360/profile/855dc38a-0439-4e53-9f69-514ddbf093ab" target="__blank">
                  <img src={codingNinjaLogo} alt="profile" />
                </a>
              </div>
              <div>
                <a href="https://www.geeksforgeeks.org/user/thakurprathya/" target="__blank">
                  <img src={gfgLogo} alt="profile" />
                </a>
              </div>
            </div>
            <div className='about-txt badges'>
              <a href="https://holopin.io/@thakurprathya" target="_blank">
                <img src="https://holopin.me/thakurprathya" alt="An image of @thakurprathya's Holopin badges, which is a link to view their full Holopin profile"/>
              </a>
            </div>
            <a href={mainLink} download="thakurPrathyaCV" className='download-btn'>Download CV <BiDownload/></a>
          </div>
      </motion.div>
      <motion.img whileInView={{scale:[0,1]}} transition={{duration:1, ease:'easeInOut'}} src={images.circleDark} alt='profile_circle' className='overlay_circle'/>
    </div>
  )
}

export default AppWrap(Header, 'home');  //using HOC and setting header as home